import { IHeaderTableForecast } from "@/types/header-forecast-table";

import iconTemp from "@/img/temp-icon.svg";
import iconWindSpeed from "@/img/wind-speed-icon.svg";
import iconWindDirection from "@/img/wind-direction-map-icon.svg";
import iconSignificantWeather from "@/img/icon-weather-responsive/significant-weather-icon.svg";
import iconPrecipitation from "@/img/precipitation-icon.svg";
import iconHumidity from "@/img/humidity-icon.svg";
import iconAirPollution from "@/img/icon-weather-responsive/air-pollution-icon.svg";

export const labelHeader: IHeaderTableForecast[] = [
	{
		key: "time",
	},
	{
		key: "significantWeather",
		icon: iconSignificantWeather,
	},
	{
		key: "airTemperature",
		icon: iconTemp,
	},
	{
		key: "precipitationAccumulationMm",
		icon: iconPrecipitation,
	},
	{
		key: "windDirection",
		icon: iconWindDirection,
	},
	{
		key: "windSpeedKmh",
		icon: iconWindSpeed,
	},
	{
		key: "relativeHumidity",
		icon: iconHumidity,
	},
	{
		key: "airPollution",
		icon: iconAirPollution,
	},
];
